// Textarea (M1): corpo HTML/texto do editor de versão de template. Mesmo estilo visual do Input.
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';
import { controlDisabled, controlFocus, controlInvalid, controlSurface } from '../lib/control';

export type TextareaProps = ComponentProps<'textarea'>;

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-24 w-full px-3 py-2 text-body',
        controlSurface,
        controlFocus,
        controlInvalid,
        controlDisabled,
        className,
      )}
      {...props}
    />
  );
}
